<template>
    <ul class="betshops__shops-list">
        <ShopInfo
            v-for="shop in shops"
            :key="shop.id"
            :city="shop.city"
            :address="shop.address"
            :openingHour="shop.openingHour"
            :closingHour="shop.closingHour"
            @click.native="$emit('shopListClick', shop)"
        />
    </ul>
</template>

<script>
    import ShopInfo from './ShopInfo';

    export default {
        name: 'ShopList',
        props: {
            shops: {
                type: Array,
                required: true,
            },
        },
        components: {
            ShopInfo,
        }
    };
</script>

<style scoped>
    .list {
        overflow-y: auto;
        height: 300px;
        min-width:320px;
    }
</style>


// WEBPACK FOOTER //
// src/app/modules/country/shops/components/ShopList.vue